import React, { FC, HTMLProps, useMemo } from 'react';
import classNames from 'classnames';
import styles from './Badge.module.scss';

export type BadgeColor = 'primary' |
'gray' |
'danger' |
'success' |
'warning' |
'gray-blue' |
'blue-light' |
'blue' |
'indigo' |
'purple' |
'pink' |
'orange';

interface IBadgeProps extends Omit<HTMLProps<HTMLDivElement>, 'size'> {
  variant?: BadgeColor
  pill?: boolean
  dot?: boolean
  size?: 'sm' | 'md' | 'lg'
  qaElement?: string
}

const Badge: FC<IBadgeProps> = ({
  className, variant = 'gray', pill, dot, size = 'md', children, qaElement, ...props
}) => {
  const colorClass = useMemo(() => styles[`${variant}`], [styles, variant]);
  const sizeClass = useMemo(() => styles[`${size}`], [styles, variant]);

  return (
    <div
      className={classNames(
        className,
        styles.badge,
        colorClass,
        sizeClass,
        styles[size],
        {
          [styles.pill]: pill,
          [styles.dot]: dot,
        },
      )}
      {...(qaElement && { 'qa-element': qaElement })}
      {...props}
    >
      {children}
    </div>
  );
};

export default Badge;
